import * as u from '@virtuoso.dev/urx'

export const domIOSystem = u.system(
  () => {
    const scrollContainerState = u.stream<[number, number]>()
    const scrollTop = u.stream<number>()
    const deviation = u.statefulStream(0)
    const smoothScrollTargetReached = u.stream<true>()
    const statefulScrollTop = u.statefulStream(0)
    const viewportHeight = u.stream<number>()
    const scrollHeight = u.stream<number>()
    const headerHeight = u.statefulStream(0)
    const footerHeight = u.statefulStream(0)
    const scrollTo = u.stream<ScrollToOptions>()
    const scrollBy = u.stream<ScrollToOptions>()
    const scrollingInProgress = u.statefulStream(false)

    u.connect(
      u.pipe(
        scrollContainerState,
        u.map(([scrollTop]) => scrollTop)
      ),
      scrollTop
    )

    u.connect(
      u.pipe(
        scrollContainerState,
        u.map(([, scrollHeight]) => scrollHeight)
      ),
      scrollHeight
    )

    u.connect(scrollTop, statefulScrollTop)

    return {
      // input
      scrollContainerState,
      scrollTop,
      viewportHeight,
      headerHeight,
      footerHeight,
      scrollHeight,
      smoothScrollTargetReached,

      // signals
      scrollTo,
      scrollBy,

      // state
      statefulScrollTop,
      deviation,
      scrollingInProgress,
    }
  },
  [],
  { singleton: true }
)
